import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useCart from 'services/cart/hooks/use-cart'
import useRemoveFromCart from 'services/googleAnalytics/use-remove-from-cart'

function RemoveFromCartOnClick ({ id, quantity, name, price, children }) {
  const cart = useCart()

  const handleClick = () => {
    cart.delete(id.toString())
    useRemoveFromCart(id, name, price, quantity)
  }

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  )
}

RemoveFromCartOnClick.defaultProps = {
  id: null,
  price: null,
  name: ''
}

RemoveFromCartOnClick.propTypes = {
  id: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}

export default observer(RemoveFromCartOnClick)
